export default "__VITE_ASSET__pPzu_CqP__"